export default {
  apiResp: 'YYYYMMDDHHmmss',
};
